import Vue from 'vue'
import VueRouter from 'vue-router'
// import Detail from '../views/Detail.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Result',
    component: () => import(/* webpackChunkName: "about" */ '../views/Result.vue')
  },
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
